export default {
  "discard-changes": "Discard changes",
  "apply-changes": "Apply changes",
  operation: "Operation",
  "select-other-operation": "Select other Operation to multiple orders",
  "delivery-from-to": "Delivery From / To",
  "modify-date": "Modify date to apply to multiple orders",
  "estimated-time": "Estimated Time",
  "modify-estimated-time": "Modify the time estimation to multiple orders",
  team: "Team",
  "modify-team": "Change team assignment to multiple orders",
  services: "Services",
  "modify-services": "Modify services to multiple orders",
  "processing-request": "Processing request...",
  "action-few-minutes": "This action could take few minutes.",
  "check-process":
    "You can check the process anytime from the Background Requests section.",
  "close-window": "Close this window",
  "open-background": "Open Background Requests",
  "change-status": "Change Status",
  "modify-status": "Apply a new status to a maximum of 500 orders",
  "change-orders": "Change Order Details",
  "modify-orders": "Change details to a maximum of 500 orders",
  "change-tags": "Add Tags",
  "modify-tags": "Apply same tags to a maximum of 500 orders",
  "change-comments": "Add Comments",
  "modify-comments": "Add a comment to a maximum of 500 orders",
  "change-incidence": "Open Incidence",
  "modify-incidence": "Open same incidence to a maximum of 500 orders",
  "change-files": "Attach a File",
  "modify-files": "Upload the same file to a maximum of 50 orders",
  "change-billing": "Recalculate Billing",
  "modify-billing": "Recalculate billing items on multiple orders",
  accepting: "Be sure to be right before accepting",
  "change-count": "You are about to change { count } orders",
  modified: "Modified",
  "reason-change": "Specify a reason for the change",
  "new-time": "Specify New Estimated Time",
  "new-operation": "Select New Operation",
  "new-services": "Select new services",
  "new-team": "Select New Team",
  "new-comment": "Write comment",
  status: "Status",
  "new-tags": "Select new tags",
};
